<template>
  <div>
    <AppHeader />
    <div v-if="loaded" class="team">
      <div
        class="team__preview"
      >
        <v-container
          class="team__preview-inner"
        >
          <v-layout
            row
            class="white--text"
          >
            <v-flex
              xs12
              class="team__info"
            >
              <div class="team__about">
                <v-avatar
                  :size="100"
                  color="grey lighten-4"
                  class="team__avatar"
                >
                  <img
                    v-if="getTeam.avatar"
                    :src="getTeam.avatar"
                    alt="avatar"
                  >
                  <i
                    v-else
                    class="fas fa-user fa-3x"
                    style="height: 40px; width: 40px; color: #212121"
                  />
                </v-avatar>
                <h3 class="team__about-title">
                {{getTeam.name}}
                </h3>
              </div>

            <div
              class="team__activities"
            >
              <div class="team__activities-item">
                <h3 class="team__activities-title teal--text text--lighten-2">
                  NMG Miles
                </h3>
                <div class="team__activities-value">
                {{getTeam.total_nmg_miles}}
                </div>
              </div>
              <!-- <div class="team__activities-item">
                <h3 class="team__activities-title teal--text text--lighten-2">
                  ZAR
                </h3>
                <div class="team__activities-value">
                  {{getTeam.total_zar}}
                </div>
              </div> -->
            </div>
                        </v-flex>
          </v-layout>
        </v-container>
      </div>
      <v-container >
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
          >
            <v-btn
              v-if="isTeamOwner"
              large
              round
              outline
              color="grey darken-1"
              @click.stop="editTeamDialogOpen"
              style="width: 150px"
            >
              Edit team
            </v-btn>
            <v-btn
              v-if="isTeamOwner"   
              large
              round
              outline
              color="grey darken-1"
              @click.stop="editTeamMembersDialog = true"
              style="width: 150px"
            >
              Edit members
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container grid-list-xl>
        <v-layout>
          <h3 class="app-title">
            Team
            {{getTeam.name}}
            members
          </h3>
        </v-layout>
<!--        <v-layout row v-for="(item, index) in getTeam.members_detail" :key="item.id">-->
<!--          <v-flex xs3>-->
<!--            <v-btn-->
<!--              class="team-activity__total_link"-->
<!--              @click="redirectToProfile(item.id)"-->
<!--              outline-->
<!--              round-->
<!--              block-->
<!--              color="black"-->
<!--            >-->
<!--              <v-avatar-->
<!--                :size="25"-->
<!--                color="grey lighten-4"-->
<!--                class="team-activity__total_avatar"-->
<!--              >-->
<!--                <img-->
<!--                  v-if="item.avatar"-->
<!--                  :src="item.avatar"-->
<!--                  alt="avatar"-->
<!--                >-->
<!--                <i-->
<!--                  v-else-->
<!--                  class="fas fa-user fa-3x"-->
<!--                  style="color: #212121;font-size: 1rem;"-->
<!--                />-->
<!--              </v-avatar>-->
<!--              <v-spacer />-->
<!--              <span v-bind:style="{fontSize: '12px'}">{{item.short_name}}</span>-->
<!--             </v-btn>-->
<!--          </v-flex>-->
<!--          <v-flex xs3 class="team-activity__total team-activity__total_nmg">{{item.total_nmg_miles}} NMG Miles</v-flex>-->
<!--          <v-flex xs3 class="team-activity__total team-activity__total_zar">{{item.total_zar}} ZAR</v-flex>-->
<!--         </v-layout>-->
        <v-layout>
          <v-flex class="swiper-container">
          <div class="swiper-navigation swiper-button-prev" @click="swiper.slidePrev()"></div>
            <!-- swiper -->
          <swiper class="swiper-slider-container" v-if="loaded" :options="swiperOption" ref="swiper">

            <swiper-slide
              class="team-slider py-2"
              v-for="(item, index) in getTeam.members_detail"
              :key="item.id"
            >
              <v-card
                class="team-slider__item text-xs-center pt-3 mx-1"
                style="cursor: pointer;"
                @click="redirectToProfile(item.id)"
              >
                <!-- <v-avatar
                  :size="75"
                  color="grey lighten-4"
                  class="team-activity__total_avatar"
                  style="border-top-left-radius: 100%; border-top-right-radius: 100%; border-bottom-left-radius: 100%; border-bottom-right-radius: 100%;"
                >
                  <img
                    v-if="item.avatar"
                    :src="item.avatar"
                    alt="avatar"
                  >
                  <i
                    v-else
                    class="fas fa-user fa-4x"
                    style="color: #212121; border-radius: 100%;"
                  />
                </v-avatar> -->
                <v-card-title
                  class="sider-title subheading text-xs-center font-weight-bold"
                  style="justify-content: center;"
                >
                  {{ item.short_name }}
                </v-card-title>
                <!-- <hr>  -->
                <v-card-title
                  class="slider-miles-title d-block text-xs-left"
                >
                  <div
                    class="nmg-miles-slider-block"
                  >
                  <!-- {{item.total_nmg_miles}} NMG Miles -->
                    <div
                      class="font-weight-bold"
                    >
                      {{item.total_nmg_miles}}
                    </div>
                    <div
                      class="grey--text darken-1"
                    >
                      NMG Miles
                    </div>
                  </div>
                  <!-- <span
                    class="d-block"
                  >
                    <span
                      class="font-weight-bold"
                    >
                      {{item.total_zar}}
                    </span>
                    <span
                      class="grey--text darken-1"
                    >
                      ZAR
                    </span>
                  </span> -->
                </v-card-title>
              </v-card>
            </swiper-slide>
          </swiper>
          <div class="swiper-navigation swiper-button-next" @click="swiper.slideNext()"></div>
          </v-flex>
        </v-layout>
      </v-container>
      
      <v-container>
        <v-layout>
          <v-flex
            xs12
          >
            <h3 class="app-title">Recent activity</h3>
            <div class="team-statistics">
              <table class="team-statistics__table text-left">
                <tr>
                    <th class="team-statistics__table-heading">
                    Member
                  </th>
                  <th class="team-statistics__table-heading">
                    Activity
                  </th>
                  <th
                    class="team-statistics__table-heading"
                  >
                    Amount
                  </th>
                  <th
                    class="team-statistics__table-heading"
                  >
                    Date
                  </th>
                 <!--  <th
                    class="team-statistics__table-heading"
                  >
                    Action
                  </th>-->
                </tr>
                <tr v-for="activity in getTeam.recent_activity"
                    :key="activity.id">
                <td class="team-statistics__table-cell">
                    {{activity.track_username}}
                  </td>
                  <td class="team-statistics__table-cell">
                    {{activity.activity}}
                  </td>
                  <td class="team-statistics__table-cell">
                    {{activity.points}} <span class="team-statistics__activity-value grey--text darken-1">{{activity.input}}</span>
                  </td>
                  <td class="team-statistics__table-cell team-statistics__date grey--text darken-1">
                    {{activity.date_record}}
                  </td>
                 </tr>
              </table>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog
        v-model="editTeamDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        dark
        class="edit-dialog"
      >
        <div
          class="edit-dialog__inner"
        >
          <v-toolbar
            fixed
            dark
            color="dark"
          >
            <v-btn
              icon
              dark
              @click="editTeamDialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Edit team</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                flat
                @click="editTeamDialogSave"
              >
                Save
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
              >
                <v-form>
                  <div class="edit-dialog__avatar">
                    <v-avatar
                      :size="150"
                      color="grey lighten-4"
                      class="team__avatar"
                    >
                      <img
                        v-if="getTeam.avatar"
                        :src="getTeam.avatar"
                        alt="avatar"
                      >
                      <i
                        v-else
                        class="fas fa-user fa-5x"
                        style="color: #212121"
                      />
                    </v-avatar>
                    <v-btn
                      color="teal lighten-2"
                      @click='pickFile'
                      flat
                      class="edit-dialog__button"
                    >
                      Change photo
                    </v-btn>
                    <input
                      name="avatar"
                      type="file"
                      style="display: none"
                      ref="changeTeamImage"
                      accept="image/*"
                      @change="onFilePicked"
                    >
                  </div>
                  <v-text-field
                  v-if="isTeamOwner"   
                    color="teal lighten-2"
                    outline
                    class="theme round"
                    label="name"
                    :error-messages="getError['name']"
                    prepend-inner-icon="fas fa-user fa-1x"
                    v-model="teamForm.name"
                  />
                  <span color="white">{{getError['detail']}}</span>
              <!--   <v-text-field
                    color="teal lighten-2"
                    outline
                    class="theme round"
                    label="New password"
                    type="password"
                    v-model="teamForm.password"
                    prepend-inner-icon="fas fa-key fa-1x"
                  />
                  <v-text-field
                    color="teal lighten-2"
                    outline
                    class="theme round"
                    label="New password again"
                    type="password"
                    v-model="teamForm.repassword"
                    prepend-inner-icon="fas fa-key fa-1x"
                  />-->
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </v-dialog>
     
      <v-dialog
        v-model="editTeamMembersDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        dark
        class="edit-dialog"
      >
        <div
          class="edit-dialog__inner"
        >
          <v-toolbar
            fixed
            dark
            color="dark"
          >
            <v-btn
              icon
              dark
              @click="editTeamMembersDialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Edit team members</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                flat
                @click="editTeamMembersDialogSave"
              >
                Remove
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
              >
                <v-form>
                  <table class="edit-dialog__table" valign="top">
                    <tr>
                      <th
                        class="edit-dialog__table-heading edit-dialog__table-row-checkbox"
                      >
                        <v-checkbox
                          color="teal lighten-2"
                        />
                      </th>
                      <th
                        class="edit-dialog__table-heading"
                      >
                        Member
                      </th>
                    </tr>
                    
                    <tr  v-for="member in filtredMembersDetail"
                          :key="member.id">
                      <td
                        class="edit-dialog__table-row-checkbox"
                      >
                        <v-checkbox
                        v-model="membersToDelete"
                        v-bind:value="member.id"
                          color="teal lighten-2"
                        />
                      </td>
                      <td>
                        <v-avatar
                          :size="25"
                          color="amber darken-3"
                          class="mr-2"
                        >
                          <img
                            v-if="member.avatar"
                            :src="member.avatar"
                            alt="avatar"
                          >
                          <i
                            v-else
                            class="fas fa-user fa-sm"
                            style="color: #212121"
                          />
                        </v-avatar>
                        <span>{{member.short_name}}</span>
                        
                      </td>
                    </tr>
                  </table>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </v-dialog>

      <BottomNavigation />
    </div>
         <div v-else >
    <v-progress-linear :indeterminate="true"></v-progress-linear>
  </div>
  </div>
  
</template>

<script>
  import AppHeader from '../components/AppHeader';  
  import BottomNavigation from "../components/BottomNavigation";
  import "swiper/dist/css/swiper.css";
  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import { mapGetters } from "vuex";

  export default {
    name: "Team",
    components: {
      AppHeader,
      BottomNavigation,
      swiper,
      swiperSlide
    },
    data() {
      return {
        editTeamDialog: false,
        loaded: false,
       // editTeamImageDialog: false,
        editTeamMembersDialog: false,
        trackDeleteConfirmDialog: false,
        track: '',
        user_activity: false,
        selectedFile: null,
        membersToDelete: [],
        teamForm: {},
        swiperOption: {
          autoHeight: true,
          slidesPerView: 6,
          spaceBetween: 5,
          // init: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          breakpoints: {
            1024: {
              slidesPerView: 5,
              spaceBetween: 20
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 20
            },
            640: {
              slidesPerView: 3,
              spaceBetween: 10
            },
            320: {
              slidesPerView: 2,
              spaceBetween: 10
            }
          }
        }
      };
    },
    computed: {
      ...mapGetters(
        'team', ['getTeam', 'getError'],

        ),
      ...mapGetters(
        'user', ['user', 'error'],
        ),
      isTeamOwner: function(){
       return this.getTeam.owner === this.user.id;
      },
      isTeamMember: function(){
        return this.getTeam.members.includes(this.user.id);
      },

      filtredMembersDetail: function(){
        return this.getTeam.members_detail.filter(i => i.id != this.user.id)
      },
      swiper() {
        return this.$refs.swiper.swiper;
      }
    },
    mounted() {
        this.$store.dispatch('user/getUser');
        this.$store.dispatch('team/loadTeam', this.$route.params.id).then(() => {
          this.swiperOption.slidesPerView = this.getTeam.members.length >= 6 ? 6 : this.getTeam.members.length;
          this.loaded = true;
          })
          .catch(err => {
            
            });
    },
    methods: {
      redirectToProfile: function(user_id){
        //const user_id = localStorage.getItem('user_id');
        //this.$store.dispatch('user/getUser', user_id);
        this.$router.push(`/user/${user_id}`);
      },
      editTeamMembersDialogSave: function(){
        let formData = new FormData();
        const team_id = this.$route.params.id;
        //const members = this.getTeam.map(i => members.push(i.id ));
        self = this
        const members = this.getTeam.members.filter(function(obj) { return self.membersToDelete.indexOf(obj) == -1; });
        members.map(i => formData.append('members', i ));
       this.$store
       .dispatch('team/updateTeam', {team_id, formData}).then(() => {
         this.editTeamMembersDialog= false;
         })
         .catch(err => {
           this.editTeamMembersDialog = true;
           });
      },
      editTeamDialogOpen: function(){
        this.editTeamDialog = true;
        this.selectedFile = null;
        this.teamForm = {...this.getTeam};
      },
      editTeamDialogSave: function (){
        const team_id = this.$route.params.id;
        const formData = new FormData();
        formData.append('name', this.teamForm.name);
        if (this.selectedFile){
          formData.append('avatar',  this.selectedFile )
        }
        this.$store.dispatch('team/updateTeam',  {team_id, formData}).then(() => {
          this.editTeamDialog = false;
          }).catch(err => {
            this.editTeamDialog = true;
            });
      },
      pickFile () {
        this.$refs.changeTeamImage.click ()
      },
      onFilePicked (e) {
        const files = e.target.files;
        this.selectedFile = event.target.files[0];
      }
    }
  }
  
</script>

<style scoped>
  .team {
    padding-bottom: 100px;
  }

  .team__preview {
    background-color: #212121;
  }

  .team__preview-inner {
    padding: 30px 45px;
  }

  .team__info {
    display: flex;
    /*flex-direction: column;*/
    justify-content: space-between;
    /*min-height: 230px;*/
  }

  .team__avatar {
    margin-bottom: 15px;
  }

  .swiper-container {
    display: flex;
    justify-content: center;
  }

  .sider-title {
    /* height: calc(100% - 72px);  */
    padding: 0 5px 5px 5px;
  }

  .nmg-miles-slider-block {
    text-align: center;
  }

  .slider-miles-title {
    border-top: 1px solid #9c9c9c;
    padding: 2px 8px 0 8px;
    /* height: 80px;  */
    /* margin-bottom: 8px; */
  }

  .team__about {
  }

  .team__about-title {
    font-size: 18px;
    margin-bottom: 5px;
  }

  .swiper-slider-container {
    width: 100%;
    margin: 0 30px 0 30px;
  }

  /* .swiper-button-prev, .swiper-button-next {
    position: unset;
    justify-content: center;
    height: auto !important; 
    padding: 12px;
    width: 27px;
    height: 44px;
    z-index: 10;
    cursor: pointer;
    background-size: 27px 44px;
    background-position: center;
    background-repeat: no-repeat;
    margin-top: 0;
    --swiper-theme-color: #c62828;
  } */

  .swiper-button-prev {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0,22L22,0l2.1,2.1L4.2,22l19.9,19.9L22,44L0,22L0,22L0,22z' fill='%23c62828'/%3E%3C/svg%3E");
  }

  .swiper-button-next {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27,22L27,22L5,44l-2.1-2.1L22.8,22L2.9,2.1L5,0L27,22L27,22z' fill='%23c62828'/%3E%3C/svg%3E");
  }

  .swiper-button-disabled {
    opacity: 0 !important;
  }

  .team-slider {
    width: auto;
    max-width: 150px;
    padding-bottom: 3px !important;
    height: calc(100% - 11px);
  }

  .team-slider__item {
    padding-top: 8px !important;
    display: grid;
    grid-template-rows: 1fr 1fr;
    height: calc(100% - 8px);
  }

  .team-slider__item:hover {
    box-shadow: 1px 5px 10px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12) !important;
  }

  .team__activities {
   /* display: flex;*/
    flex-direction: column;
    justify-content: space-around;
  }

  .team__activities-item {
    text-align: center;
    position: relative;
    margin-bottom: 35px;
  }

  .team__activities-title {
    font-family: "Roboto", sans-serif;
    text-transform: uppercase;
    font-weight: 400;
    margin-bottom: 2px;
  }

  .team-activity__total {
    display: flex;
    align-items: center;
  }

  .team__activities-value {
    font-weight: bold;
  }

  .team__slider-item {
    text-align: center;
  }

  .team__slider-avartar {
    border: 3px solid;
    padding: 3px;
    background-color: #fff !important;
    display: block;
    box-shadow: 0 1px 5px #fc9667;
    margin-bottom: 5px;
  }

  .team__slider-name {

  }

  .edit-dialog {

  }
  
  .edit-dialog__inner {
    background-color: #212121;
    min-height: 100vh;
    padding-top: 90px;
  }

  .edit-dialog__title {
    text-align: center;
    font-size: 24px;
  }

  .edit-dialog__avatar {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 30px;
    overflow: hidden;
  }

  .edit-dialog__button {
    width: 100%;
    height: 56px;
  }

  .edit-dialog__table {
    width: 100%;
    color: #fff;
    text-align: left;
    border-spacing: 0px;
    border-collapse: collapse;
  }

  .edit-dialog__table-heading {
    border-bottom: 1px solid #fff;
  }

  .edit-dialog__table-row-checkbox {
    width: 45px;
  }

  .team-statistics {

  }

  @media (min-width: 768px) {
    .team-statistics {
      /*padding: 0 10px;*/
    }
  }

  .team-statistics__table {
    width: 100%;
    /*text-align: left;*/
    border-spacing: 0px;
    border-collapse: collapse;
    font-size: 12px;
    line-height: 1;
  }


  .team-statistics__table-heading {
    padding: 5px 10px;
    text-align: left;
  }

  .team-statistics__table-cell {
    padding: 5px 10px;
  }

  .team-activity__total_zar {
    color: black;
    font-weight: bold;

  }
  .team-activity__total_nmg {
    color: black;
    font-weight: bold;


  }
  .team-activity__total_username{
  

  }
  .v-btn .v-btn__content{
    justify-content: right;
  }
</style>


